<template>
<div class="bg-white">
<div class="container">

	<h2>
		Message Threads<br>
		<small>
			 #{{ $store[jobType].job_num }}<span v-if="$store[jobType].job_name">: {{$store[jobType].job_name}}</span>
		</small>
	</h2>

	<message-thread-card
		v-for="thread in mutatedThreads"
		:key="thread.id"
		:thread="thread"
		:image-url="thread.imageUrl"
		v-on:click="selectThread(thread)">
	</message-thread-card>

	<div v-if="threads.length == 0">
		No threads yet in this {{jobType}}
	</div>

</div>
</div>
</template>

<script>
import MessageThreadCard from "../../layout_fragments/messages/MessageThreadCard"
import Widget from "@/components/Widget"

export default {

	name: 'JobMessages',
	components: {
		MessageThreadCard,
		Widget
	},
	data() {
		return {
			threads: [],
			threadProfileImages: []
		}
	},
	computed: {
		jobType() {
			if (this.$route.path.indexOf("service") >= 0) 
				return "service"
			else if (this.$route.path.indexOf("project") >= 0)
				return "project"
		},
		mutatedThreads() {
			let vm = this

			let mutated =  this.threads.map(thread => {
				return vm.attachImageToThread(thread,vm.threadProfileImages)
			})

			return mutated
		}
	},
	methods: {
		selectThread(thread){
			let vm = this

			if (window.innerWidth < this.$store.messagePanelBreakpoint) {
				this.$router.push("/message/"+thread.slug)
			}
			else {
				this.$bus.$emit("openMessagePanel")
				this.$nextTick(() => {
					vm.$bus.$emit("openThread",thread.slug)
				})
			}	
		},
		fetchJobMessageThreads() {
			this.spinner(true)

			let vm = this

			let jobField = "job_id"
			if (this.jobType == "service")
				jobField = "service_id"

			let params = {
				include: [
					{model: "User",fields: ["id","slug","first_name","last_name","image_id"]},
					{model: "Job",fields: ["id","slug","job_name","job_num"]},
					{model: "Service",fields: ["id","slug","job_name","job_num"]}
				],
				filters: [
					[jobField,this.$store[this.jobType].id]
				]
			}

			this.getJSON("MessageThread/get",params).then(response => {
				vm.spinner(false)

				vm.threads = response.data

				vm.fetchProfileImages(vm.threads).then(images => {
					vm.threadProfileImages = images
				})
				
			})
		}
	},
	created() {
		let vm = this

		let fetchTimer = setInterval(() => {
			if ("id" in vm.$store[vm.jobType]) {
				vm.fetchJobMessageThreads()
				clearInterval(fetchTimer)
			}
		},100)

		this.$bus.$on("newThreadCreated",this.fetchJobMessageThreads)
	}

}
</script>

<style type="text/css">

</style>